module["exports"] = ["#{first_name} #{last_name}", "#{last_name} #{first_name}"];